
/*************************** 微信客户端重定向 ***************************/
import { getQueryString, getParams, removeUrlParams } from '@/utils/js/utils.js';
import { getOpenId } from '@/api/ApiWx.js';
import config from '@/config/config.js';
export const getOpenIdUtil = (to, from, next) => {
  let urlParams = getParams();
  // 解决ios的SPA
  let url = location.origin + location.pathname.split("html")[0] + 'html' + to.fullPath
  let u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  to.meta.wx = to.meta.wx || {};
  if (isiOS && (urlParams.client === 'wx') && (to.meta.wx.isShare || to.meta.wx.customShare)) {
    if (url !== location.href) {
      window.location.replace(url)
      return;
    } else {
      next();
    }
  }
  next();
}

export const wxRedirect = function () {
  let promise = new Promise((resolve) => {
    let code = getQueryString('code') || sessionStorage.getItem('code') || '';
    sessionStorage.setItem('code', code);
    if (!code) {
      // 如果申请到appId后用这种授权
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appId}&redirect_uri=${config.domainURL}?client=WX&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    } else {
      resolve()
    }
  })
  return promise;
};